"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processNameInline = void 0;
const error_1 = require("../../parser/cst/error");
const controls_1 = require("../../node/el/controls");
const _nameInline_1 = __importDefault(require("../sentenceChildrenParser/rules/$nameInline"));
const env_1 = require("../sentenceChildrenParser/env");
const sentenceEnv_1 = require("../../node/container/sentenceEnv");
const getScope_1 = __importDefault(require("../pointerEnvs/getScope"));
const processNameInline = (elToBeModified, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct) => {
    const errors = [];
    const declarations = [];
    for (let i = 0; i < elToBeModified.children.length; i++) {
        const result = _nameInline_1.default.match(i, elToBeModified.children, (0, env_1.initialEnv)({ target: "" }));
        if (result.ok) {
            const { nameSquareParentheses, following, pointerRanges } = result.value.value;
            if (pointerRanges)
                (0, getScope_1.default)({ pointerRangesToBeModified: pointerRanges, pointerEnvsStruct });
            errors.push(...result.value.errors);
            const name = nameSquareParentheses.content.text();
            const followingStartPos = following ? {
                sentenceIndex: sentenceEnv.index,
                textOffset: sentenceEnv.textRageOfEL(nameSquareParentheses)?.[1] ?? 0,
            } : null;
            const scope = (0, sentenceEnv_1.toSentenceTextRanges)(pointerRanges?.targetContainerIDRanges ?? null, sentenceEnvsStruct, followingStartPos);
            if (scope.length === 0) {
                errors.push(new error_1.ErrorMessage("No scope found", [
                    pointerRanges?.range?.[0] ?? 0,
                    pointerRanges?.range?.[1] ?? 0,
                ]));
            }
            const nameTextRange = sentenceEnv.textRageOfEL(nameSquareParentheses.content);
            if (!nameTextRange) {
                errors.push(new error_1.ErrorMessage("nameTextRange is null", [
                    pointerRanges?.range?.[0] ?? 0,
                    pointerRanges?.range?.[1] ?? 0,
                ]));
                continue;
            }
            const nameSentenceTextRange = {
                start: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: nameTextRange[0],
                },
                end: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: nameTextRange[1],
                },
            };
            const declarationID = `decl-sentence_${sentenceEnv.index}-text_${nameTextRange[0]}_${nameTextRange[1]}`;
            const declaration = new controls_1.____Declaration({
                declarationID,
                type: "Keyword",
                name,
                value: {
                    isCandidate: true,
                    sentenceTextRange: {
                        start: {
                            sentenceIndex: sentenceEnv.index,
                            textOffset: 0,
                        },
                        end: {
                            sentenceIndex: sentenceEnv.index,
                            textOffset: sentenceEnv.textRageOfEL(pointerRanges ?? nameSquareParentheses)?.[0] ?? 0,
                        },
                    },
                },
                scope: scope,
                nameSentenceTextRange,
                range: nameSquareParentheses.content.range,
                children: [name],
            });
            declarations.push(declaration);
            nameSquareParentheses.content.children.splice(0, nameSquareParentheses.content.children.length, declaration);
        }
    }
    return {
        value: { declarations },
        errors,
    };
};
exports.processNameInline = processNameInline;
//# sourceMappingURL=processNameInline.js.map